/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HtmlPageConfigInfoRespVo } from './HtmlPageConfigInfoRespVo';
import {
    HtmlPageConfigInfoRespVoFromJSON,
    HtmlPageConfigInfoRespVoFromJSONTyped,
    HtmlPageConfigInfoRespVoToJSON,
    HtmlPageConfigInfoRespVoToJSONTyped,
} from './HtmlPageConfigInfoRespVo';

/**
 * 
 * @export
 * @interface PageDataHtmlPageConfigInfoRespVo
 */
export interface PageDataHtmlPageConfigInfoRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataHtmlPageConfigInfoRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataHtmlPageConfigInfoRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataHtmlPageConfigInfoRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<HtmlPageConfigInfoRespVo>}
     * @memberof PageDataHtmlPageConfigInfoRespVo
     */
    records?: Array<HtmlPageConfigInfoRespVo>;
}

/**
 * Check if a given object implements the PageDataHtmlPageConfigInfoRespVo interface.
 */
export function instanceOfPageDataHtmlPageConfigInfoRespVo(value: object): value is PageDataHtmlPageConfigInfoRespVo {
    return true;
}

export function PageDataHtmlPageConfigInfoRespVoFromJSON(json: any): PageDataHtmlPageConfigInfoRespVo {
    return PageDataHtmlPageConfigInfoRespVoFromJSONTyped(json, false);
}

export function PageDataHtmlPageConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataHtmlPageConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(HtmlPageConfigInfoRespVoFromJSON)),
    };
}

export function PageDataHtmlPageConfigInfoRespVoToJSON(json: any): PageDataHtmlPageConfigInfoRespVo {
    return PageDataHtmlPageConfigInfoRespVoToJSONTyped(json, false);
}

export function PageDataHtmlPageConfigInfoRespVoToJSONTyped(value?: PageDataHtmlPageConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(HtmlPageConfigInfoRespVoToJSON)),
    };
}

